export let CssDataTypeEnum = /*#__PURE__*/function (CssDataTypeEnum) {
  CssDataTypeEnum["UNKNOWN_CssDataType"] = "UNKNOWN_CssDataType";
  CssDataTypeEnum["number"] = "number";
  CssDataTypeEnum["string"] = "string";
  CssDataTypeEnum["angle"] = "angle";
  CssDataTypeEnum["color"] = "color";
  CssDataTypeEnum["length"] = "length";
  CssDataTypeEnum["percentage"] = "percentage";
  CssDataTypeEnum["lengthPercentage"] = "lengthPercentage";
  CssDataTypeEnum["blendMode"] = "blendMode";
  CssDataTypeEnum["customEnum"] = "customEnum";
  CssDataTypeEnum["time"] = "time";
  return CssDataTypeEnum;
}({});
export let GroupType = /*#__PURE__*/function (GroupType) {
  GroupType["preset"] = "preset";
  return GroupType;
}({});
//# sourceMappingURL=types.js.map